import { h, Host } from "@stencil/core";
export class LazyGif {
    constructor() {
        this.show = false;
    }
    clickHandler() {
        this.show = true;
    }
    renderSrc() {
        if (!this.show) {
            return;
        }
        return h("picture", null, h("img", { src: this.src, class: "img-fluid", loading: "eager" }));
    }
    render() {
        return h(Host, { key: '7a372fc4b00bca081b4215d62499751213eccc6f', role: "button" }, h("div", { key: 'bba931662e6920e969db409eb14a2a4273abd64d', class: {
                preview: true,
                visible: !this.show
            } }, h("slot", { key: '9f0f105e001bacc69905f7329e3c223f9c543062' }), h("svg", { key: '97252f71e31e5e811a42090afa87744b19ce3133', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1792 1792", fill: "#000" }, h("path", { key: '5990cb1ce6e1a73941be04588fccf5612e1fa58b', d: "M1576 927L248 1665q-23 13-39.5 3t-16.5-36V160q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z" }))), this.renderSrc());
    }
    static get is() { return "uvex-lazy-gif"; }
    static get originalStyleUrls() {
        return {
            "$": ["./lazy-gif.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["lazy-gif.css"]
        };
    }
    static get properties() {
        return {
            "src": {
                "type": "string",
                "attribute": "src",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "show": {}
        };
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=lazy-gif.js.map
